@if (canManageTutorials$ | async) {
  <div class="edit-menu">
    <mat-icon class="edit-menu__icon" (click)="toggleMenu($event)">more_vert</mat-icon>
    <div class="menu" [hidden]="!isMenuOpened">
      <div class="menu__item" (click)="edit($event)"><i class="material-icons-outlined">edit</i>Edit tutorial</div>
      <div class="menu__item" (click)="delete($event)">
        <i class="material-icons-outlined">delete</i>Delete tutorial
      </div>
    </div>
  </div>
}
